/**
 * @desc 统一门户根据登录用户检查是否具有对应权限
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {
  /** loginId */
  loginId: string;
  /** permissionId */
  permissionId: number;
}

export function request(params: Params): Promise<defs.StandardReturn<boolean>> {
  return defHttp.get({
    url: '/portal/check/permission',

    params,
  });
}

export function mock(params: Params): Promise<defs.StandardReturn<boolean>> {
  return defHttp.get({
    url: '/mock/portal/check/permission',

    params,
  });
}
